import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { User, UserMenuPrivilege } from '../../../core/models/domain.models';

export interface StaffCreatePayload {
  username: string;
  full_name: string;
  email: string;
  role: string;
  rm_id?: string | null;
  active: boolean;
  password: string;
}

export interface StaffUpdatePayload {
  full_name?: string;
  email?: string;
  role?: string;
  rm_id?: string | null;
  active?: boolean;
  password?: string;
}

export interface StaffPrivilegePayload {
  items: Array<{
    menu_id: string;
    can_read: boolean;
    can_write: boolean;
  }>;
}

@Injectable({ providedIn: 'root' })
export class StaffService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = environment.apiBaseUrl;

  list() {
    return this.http.get<User[]>(`${this.baseUrl}/api/staff`, { withCredentials: true });
  }

  get(id: string) {
    return this.http.get<User>(`${this.baseUrl}/api/staff/${id}`, { withCredentials: true });
  }

  create(payload: StaffCreatePayload) {
    return this.http.post<User>(`${this.baseUrl}/api/staff`, payload, { withCredentials: true });
  }

  update(id: string, payload: StaffUpdatePayload) {
    return this.http.patch<User>(`${this.baseUrl}/api/staff/${id}`, payload, { withCredentials: true });
  }

  delete(id: string) {
    return this.http.delete<{ message: string }>(`${this.baseUrl}/api/staff/${id}`, { withCredentials: true });
  }

  listPrivileges(id: string) {
    return this.http.get<UserMenuPrivilege[]>(`${this.baseUrl}/api/staff/${id}/privileges`, { withCredentials: true });
  }

  savePrivileges(id: string, payload: StaffPrivilegePayload) {
    return this.http.put<UserMenuPrivilege[]>(`${this.baseUrl}/api/staff/${id}/privileges`, payload, { withCredentials: true });
  }
}
